const types = {
  GET_SESSION_TOKEN: '@@IO_session/GET_SESSION_TOKEN',
  SET_SESSION_DATA: '@@IO_session/SET_SESSION_DATA',
};

export default types;
